import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Candidates|History|Audit|Assignment Dialog';
const sharedProps: Pick<LocDef, 'htmlAllowed' | 'shared' | 'feature' | 'portal'> = {
	htmlAllowed: false,
	shared: false,
	feature: HubFeature.OtherRequirementUploadCandidateAccessAudits,
	portal: 'SP',
};

type SPCandidateHistoryAuditAssignLoc =
	| 'SPCandidateHistoryAuditAssignTitle'
	| 'SPCandidateHistoryAuditUnassignTitle'
	| 'SPCandidateHistoryAuditCancelButtonLabel'
	| 'SPCandidateHistoryAuditAssignButtonLabel'
	| 'SPCandidateHistoryAuditUnassignButtonLabel'
	| 'SPCandidateHistoryAuditAssignUserLabel'
	| 'SPCandidateHistoryAuditAssignUserRequiredError'
	| 'SPCandidateHistoryAuditAssignUserMatchError'
	| 'SPCandidateHistoryAuditUnassignConfirmationMessage'
	| 'SPCandidateHistoryAuditAssignNotificationMessage'
	| 'SPCandidateHistoryAuditUnassignNotificationMessage';
export const SPCandidateHistoryAuditAssignLocs: LocDefs<SPCandidateHistoryAuditAssignLoc> = {
	SPCandidateHistoryAuditAssignTitle: {
		defaultValue: 'Assign User',
		description: 'Dialog title for the assign user dialog.',
		displayPath: `${dpRoot}|Assign Title`,
		displayType: 'Title',
		...sharedProps,
	},
	SPCandidateHistoryAuditUnassignTitle: {
		defaultValue: 'Unassign User',
		description: 'Dialog title for the unassign user dialog.',
		displayPath: `${dpRoot}|Unassign Title`,
		displayType: 'Title',
		...sharedProps,
	},
	SPCandidateHistoryAuditCancelButtonLabel: {
		defaultValue: 'Cancel',
		description: 'Button label for the cancel button.',
		displayPath: `${dpRoot}|Cancel Button`,
		displayType: 'Button',
		...sharedProps,
	},
	SPCandidateHistoryAuditAssignButtonLabel: {
		defaultValue: 'Assign User',
		description: 'Button label for the assign user dialog.',
		displayPath: `${dpRoot}|Assign Button`,
		displayType: 'Button',
		...sharedProps,
	},
	SPCandidateHistoryAuditUnassignButtonLabel: {
		defaultValue: 'Unassign User',
		description: 'Button label for the unassign user dialog.',
		displayPath: `${dpRoot}|Unassign Button`,
		displayType: 'Button',
		...sharedProps,
	},
	SPCandidateHistoryAuditAssignUserLabel: {
		defaultValue: 'User',
		description: 'Label for the assign user field.',
		displayPath: `${dpRoot}|Assign User Label`,
		displayType: 'Label',
		...sharedProps,
	},
	SPCandidateHistoryAuditAssignUserRequiredError: {
		defaultValue: 'User is required',
		description: 'Error message for the assign user field when no user is selected.',
		displayPath: `${dpRoot}|Assign User Required Error`,
		displayType: 'Error',
		...sharedProps,
	},
	SPCandidateHistoryAuditAssignUserMatchError: {
		defaultValue: 'Please select a valid user',
		description: 'Error message for the assign user field when selected user is not valid.',
		displayPath: `${dpRoot}|Assign User Match Error`,
		displayType: 'Error',
		...sharedProps,
	},
	SPCandidateHistoryAuditUnassignConfirmationMessage: {
		defaultValue: 'Are you sure you want to unassign the user?',
		description: 'Confirmation message for the unassign user dialog.',
		displayPath: `${dpRoot}|Unassign Confirmation Message`,
		displayType: 'Content',
		...sharedProps,
	},
	SPCandidateHistoryAuditAssignNotificationMessage: {
		defaultValue: 'Audit(s) successfully assigned/reassigned.',
		description: 'Confirmation message for the assign/reassign user dialog.',
		displayPath: `${dpRoot}|Assign Confirmation Message`,
		displayType: 'Notification',
		...sharedProps,
	},
	SPCandidateHistoryAuditUnassignNotificationMessage: {
		defaultValue: 'Audit(s) successfully unassigned.',
		description: 'Confirmation message for the unassign user dialog.',
		displayPath: `${dpRoot}|Unassign Confirmation Message`,
		displayType: 'Notification',
		...sharedProps,
	},
};

export const SPCandidateHistoryAuditAssignLocKeys = MapLocKeys<SPCandidateHistoryAuditAssignLoc>(
	SPCandidateHistoryAuditAssignLocs
);
export type SPCandidateHistoryAuditAssignLocKeys = typeof SPCandidateHistoryAuditAssignLocKeys;
